import React from 'react';

import AccidentsList from './List';
export default function Index() {
  return (
    <>
      <AccidentsList />
    </>
  );
}
